const FOOTER_DATA = [
    {
      id: 1,
      title: 'movies',
      data: ['Now showing', 'Upcoming Cinemas', 'Advertise', 'Beyond Movies']
    },
    {
      id: 2,
      title: 'cinemas',
      data: ['Find a Cinema', 'Bulk Bookings', 'Events']
    },
    {
      id: 3,
      title: 'wow cinema',
      data: ["About us","FAQ's", "Investors Section","Career","Feedback","News"]
    },
    {
      id: 4,
      title: 'Promotions',
      data: ['Partnership', 'Experience','Movie Club','F&B','General']
    },
    {
      id: 5,
      title: 'Experience',
      data: ['Classic','Deluxe','Luxe','IMAX','Infinity']
    },
    {
      id: 6,
      title: 'Partner',
      data: ['Investors','Corporate Sales']
    }
  ];
  
  export default FOOTER_DATA;
  